import React from 'react';
import "../../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Hon'ble Chancellor</h1>
                <p>Home &gt; About-us &gt; Hon'ble Chancellor</p>
            </div>
        </div>
    )
}

export default Hero;